export default __webpack_public_path__ + "static/sfMono-7a2f774802f64e53ee001e5c5d6b6602.svg";